import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ProjectSearchParams from './ProjectSearchParams';
import NewProjectService from '../../../Services/NewProjectService';
import NewProjectItem from '../../../Domain/ThirdParty/Project/NewProjectItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import EditNewProjectWindowDescription from './EditNewProjectWindowDescription';
import ButtonRow from '../../../Elements/ButtonRow';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ErrorMessage from '../../../Elements/ErrorMessage';
import NewClientProjectItem from '../../../Domain/NewClientProjectItem';
import PlatformCostOverrideWindowDescription from './PlatformCostOverrideWindowDescription';
import ProjectPlatformCostOverrideItem from '../../../Domain/ThirdParty/Project/ProjectPlatformCostOverrideItem';
import InvoiceAutomationRunNow from './InvoiceAutomation/InvoiceAutomationRunNow.tsx';

export default class NewProjectAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    const searchItem = new ProjectSearchParams();
    if (props.ClientId) {
      searchItem.BravoClientId = props.ClientId;
    }

    this.state = {
      searchItem,
      selectedItem: null,
      selectedOverride: null,
      invoiceAutomationRunProject: null,
      shownPanel: ShownPanelsEnum.None,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);
    this.refresh = this.refresh.bind(this);
    this.runPlatformCostBilling = this.runPlatformCostBilling.bind(this);
    this.projectListRef = React.createRef();

    NewProjectItem.toggleWaveLinking = this.toggleWaveLinking.bind(this);
    NewProjectItem.editFunction = this.clickOnEdit.bind(this);
    NewProjectItem.platformCostOverrideFunction = this.openPlatformCostOverride.bind(this);
    NewProjectItem.invoiceAutomationFunction = this.openInvoiceAutomation.bind(this);
    NewProjectItem.runInvoiceAutomationFunction = this.openInvoiceAutomationRun.bind(this);
    // The Automatic Invoicing tab changes the setup while the popup stays open; the list's status column is loaded
    // again once the popup closes.
    NewProjectItem.invoiceAutomationChangedFunction = () => {
      this.invoiceAutomationChanged = true;
    };
    this.invoiceAutomationChanged = false;
    this.onDetailPopupClose = this.onDetailPopupClose.bind(this);
  }

  onDetailPopupClose() {
    if (this.invoiceAutomationChanged) {
      this.invoiceAutomationChanged = false;
      this.refresh();
    }
  }

  clickOnEdit(selectedId, selectedItem) {
    this.setState({
      selectedItem: { ...selectedItem },
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  openPlatformCostOverride(project) {
    NewProjectService.GetPlatformCostOverride(project.ProjectId)
      .then((result) => {
        const override = new ProjectPlatformCostOverrideItem(result, project);
        this.setState({
          selectedOverride: override,
          shownPanel: ShownPanelsEnum.PlatformCostOverride,
        });
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: NPA210. Failed to load the platform cost override.');
      });
  }

  // The setup lives on the project's Automatic Invoicing tab, so the row action opens the project there.
  openInvoiceAutomation(project) {
    this.projectListRef.current?.openDetails(project, NewProjectItem.invoiceAutomationTabName);
  }

  openInvoiceAutomationRun(project) {
    this.setState({
      invoiceAutomationRunProject: project,
      shownPanel: ShownPanelsEnum.InvoiceAutomationRun,
    });
  }

  runPlatformCostBilling() {
    ErrorMessage.SetApprove(
      'You are about to run the platform cost billing for all Prism shops that have not been billed yet. ' +
        'This is the same process that runs automatically at the start of each month. Do you want to continue?',
      () =>
        NewProjectService.RunPlatformCostBilling()
          .then((result) => {
            if (result && result.Error) {
              ErrorMessage.SetErrorMessage(result.Error);
            } else {
              ErrorMessage.SetNotification(result);
            }
          })
          .catch(() => {
            ErrorMessage.SetErrorMessage('Error! ErrorCode: NPA230. Failed to start the platform cost billing run.');
          })
    );
  }

  clickOnToggleWaveLinkingFunction(selectedItem) {
    NewProjectService.ToggleWaveLinking(selectedItem)
      .then((result) => {
        if (result && result !== 'None.' && result.errorMessage) {
          ErrorMessage.SetErrorMessage(result.errorMessage);
        } else {
          ErrorMessage.SetNotification(
            `Wave linking has been ${selectedItem.IsWaveLinkingEnabled ? 'disabled' : 'enabled'} for project ${
              selectedItem.ProjectName
            }.`
          );
        }
        this.refresh();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: NPA50. Wave linking toggle function failed!');
      });
  }

  toggleWaveLinking(selectedItem) {
    const messageText = selectedItem.IsWaveLinkingEnabled
      ? 'You are about to disable wave linking for this project. This is only possible if there are no waves linked to project.'
      : 'THIS FEATURE IS IN AN EXPERIMENTAL PHASE STILL AND ONLY AVAILABLE TO ADMINS. Are you sure you want to enable wave linking for this project?';

    ErrorMessage.SetApprove(messageText, () => this.clickOnToggleWaveLinkingFunction(selectedItem));
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  getNewProjectItem() {
    const newItem = new NewProjectItem();
    newItem.BravoClientId = this.props.ClientId;
    newItem.IsNewProject = true;
    newItem.StartDate = new Date();
    newItem.EndDate = dateTimeHelper.addDaysToDate(new Date(), 1);
    //newItem.ReimbursementType = 'Use Client Reimbursement Field';

    return newItem;
  }

  renderClientProjectPanels() {
    return (
      <div>
        {this.state.shownPanel === ShownPanelsEnum.AddNewItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.getNewProjectItem()}
            clickOnCancel={this.panelOnClose}
            clickOnSave={this.panelOnClose}
            windowDescription={EditNewProjectWindowDescription}
            errorCode={'NPA117'}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['Create']}
          colors={[ButtonColorsEnum.Primary]}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roleKeys={['project_edit']}
          className={'InnerMenuButtonFigmaList'}
          value={this.state.shownPanel}
          onClick={() => this.showPanel(ShownPanelsEnum.AddNewItem)}
        />
        {this.renderClientProjectPanels()}
      </>
    );
  }

  renderProjectPanels() {
    return (
      <div>
        {this.state.shownPanel === ShownPanelsEnum.EditItem && (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.getEditedItem()}
            clickOnCancel={this.panelOnClose}
            clickOnSave={this.panelOnClose}
            windowDescription={EditNewProjectWindowDescription}
            errorCode={'NPA127'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.PlatformCostOverride && this.state.selectedOverride && (
          <GeneralEditWizzardBase
            crudType={this.state.selectedOverride.IsNewOverride ? CrudTypesEnum.Create : CrudTypesEnum.Update}
            editedItem={this.state.selectedOverride}
            clickOnCancel={this.panelOnClose}
            clickOnSave={this.panelOnClose}
            windowDescription={PlatformCostOverrideWindowDescription}
            errorCode={'NPA220'}
          />
        )}
        {this.state.shownPanel === ShownPanelsEnum.InvoiceAutomationRun && this.state.invoiceAutomationRunProject && (
          <InvoiceAutomationRunNow
            projectId={this.state.invoiceAutomationRunProject.ProjectId}
            projectName={this.state.invoiceAutomationRunProject.ProjectName}
            onClose={this.panelOnClose}
          />
        )}
      </div>
    );
  }

  getEditedItem() {
    return { ...this.state.selectedItem, IsEditedProject: true };
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.props.ClientId && this.renderButtonsAndPanels()}
        {!this.props.ClientId && (
          <ButtonRow
            labels={['Run Platform Cost']}
            colors={[ButtonColorsEnum.Primary]}
            keys={[ShownPanelsEnum.RunPlatformCost]}
            icons={['fa-solid fa-play']}
            roleKeys={['run_platform_cost']}
            className={'InnerMenuButtonFigmaList'}
            value={this.state.shownPanel}
            onClick={this.runPlatformCostBilling}
          />
        )}
        {this.renderProjectPanels()}
        <TabOfDataTable
          ref={this.projectListRef}
          afterClickOnCancel={this.onDetailPopupClose}
          clickOnStartSearch={this.startSearch}
          searchParamsType={ProjectSearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          serviceFunction={NewProjectService.GetAllItemBySearching}
          convertDBItemsFunction={NewProjectService.ConvertDBItems}
          shownPanel={this.state.shownPanel}
          type={this.props.ClientId ? NewClientProjectItem : NewProjectItem}
          enableUrlPush={!this.props.ClientId}
          popupEnabled={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in name, code...'
          errorCode='NPA181'
        />
      </div>
    );
  }
}
